<div
  class="tooltip"
  [class.hidden]="tooltip.hidden"
  [style.left.px]="tooltip.x"
  *ngIf="interactivity"
>
  <div class="content">
    <p>
      <span class="name">{{ tooltip.name | translate }} </span>
      <span class="category">{{ tooltip.interval | translate }}</span>
    </p>
    <p>
      <span class="value">{{ tooltip.value | translate }}</span>
      <small> {{ unit | translate }}</small>
    </p>
  </div>
  <button>{{ 'Click to go to map' | translate }}</button>
</div>
<div class="legend">
  <span>{{ 'Less' | translate }}</span>
  <div
    class="color"
    [style.background-color]="color"
    *ngFor="let color of config.colors"
  ></div>
  <span>{{ 'More ' + unit | translate }}</span>
</div>
<div class="chart">
  <ng-container *ngFor="let delivery of data">
    <div class="delivery" *ngIf="!delivery.empty; else emptyTemplate">
      <div
        class="value"
        (click)="handleClick(delivery, item)"
        (mouseover)="tooltipEnter(delivery, item, $event)"
        (mouseout)="tooltipExit()"
        [class.negative]="getLightness(colorScale(item.value)) < 128"
        [style.background-color]="colorScale(item.value)"
        [class.interactive]="interactivity"
        *ngFor="let item of delivery.values"
      >
        {{ formatter(item.value) | uppercase }}
      </div>
    </div>
    <ng-template #emptyTemplate>
      <div class="empty">
        <div class="empty-value" *ngFor="let cat of categories"></div>
      </div>
    </ng-template>
  </ng-container>
  <div class="y-axis">
    <div
      *ngFor="let label of categories"
      class="label generic-tooltip right"
      [attr.data-tooltip]="label.interval | translate"
    >
      <p>
        {{ label.interval | translate }}
      </p>
    </div>
  </div>
</div>
<div class="x-axis">
  <p *ngFor="let date of xLabels">
    {{ date.label | translate }}
  </p>
</div>
